import Keycloak from 'keycloak-js';

const AccountConsole = (keycloak: Keycloak.KeycloakInstance): void => {
  keycloak.accountManagement();
};

export default AccountConsole;